import React from "react";
import {
  FaGlobe,
  FaSearch,
  FaLanguage,
  FaUsers,
  FaBrain,
  FaIndustry,
  FaKey,
  FaPlusCircle,
} from "react-icons/fa";

const PreferencePage = () => {
  const preferences = [
    {
      label: "Default Search Engine",
      icon: <FaSearch className="text-blue-500" />,
    },
    {
      label: "Target Locations / Region",
      icon: <FaGlobe className="text-teal-500" />,
    },
    {
      label: "Preferred Language",
      icon: <FaLanguage className="text-indigo-500" />,
    },
    {
      label: "Competitors added for tracking",
      icon: <FaUsers className="text-rose-500" />,
    },
  ];

  const aiSettings = [
    {
      label: "Tone for AI suggestions",
      icon: <FaBrain className="text-purple-500" />,
    },
    {
      label: "Add / Remove Websites",
      icon: <FaPlusCircle className="text-green-500" />,
    },
    {
      label: "Keywords to prioritize / Avoid",
      icon: <FaKey className="text-orange-500" />,
    },
    {
      label: "Business type / Industry focus",
      icon: <FaIndustry className="text-blue-500" />,
    },
  ];

  return (
    <>
    <p className="sr-only">
Seo Up Rank is an advanced AI powered SEO automation platform that
provides website audits, keyword research, SEO analysis, and ranking
optimization tools. Visit the official platform at https://novarsis.ai/
to improve your website search engine rankings and organic traffic.
</p>
   
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-100 via-white to-teal-100 relative overflow-hidden px-4">
      {/* Floating Background Circles */}
      <div className="absolute w-80 h-80 bg-blue-300 rounded-full blur-3xl top-10 left-10 opacity-30 animate-pulse"></div>
      <div className="absolute w-96 h-96 bg-teal-300 rounded-full blur-3xl bottom-10 right-10 opacity-40 animate-pulse"></div>

      {/* Card Container */}
      <div
        className="relative w-full max-w-md bg-white/80 backdrop-blur-lg border-l-4 border-blue-500 
        rounded-3xl shadow-2xl p-6 sm:p-8 transition-all duration-500 hover:scale-[1.03] hover:shadow-blue-200/60"
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold text-blue-800 tracking-wide">
            Preferences
          </h1>
          <button className="bg-gradient-to-r from-blue-500 to-blue-600 text-white text-sm px-5 py-1.5 rounded-full shadow-md hover:shadow-lg hover:scale-105 transition">
            Save
          </button>
        </div>

        {/* Preferences Section */}
        <div className="animate-slideUp">
          <h2 className="text-gray-800 font-semibold mb-3 border-l-4 border-blue-500 pl-2">
            General Preferences
          </h2>
          <div className="border rounded-xl divide-y overflow-hidden bg-white/70 backdrop-blur-md shadow-sm">
            {preferences.map((item, index) => (
              <div
                key={index}
                className="flex items-center gap-3 p-3 hover:bg-blue-50 transition-all duration-300 transform hover:scale-[1.02] cursor-pointer"
              >
                <span className="text-lg">{item.icon}</span>
                <span className="text-gray-700 font-medium text-sm sm:text-base hover:text-blue-700 transition ">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* AI Customization Section */}
        <div className="mt-8 animate-slideUp delay-100">
          <h2 className="text-gray-800 font-semibold mb-3 border-l-4 border-teal-500 pl-2">
            AI Customization (Automated SEO)
          </h2>
          <div className="border rounded-xl divide-y overflow-hidden bg-white/70 backdrop-blur-md shadow-sm">
            {aiSettings.map((item, index) => (
              <div
                key={index}
                className="flex items-center gap-3 p-3 hover:bg-teal-50 transition-all duration-300 transform hover:scale-[1.02] cursor-pointer"
              >
                <span className="text-lg">{item.icon}</span>
                <span className="text-gray-700 font-medium text-sm sm:text-base hover:text-teal-700 transition">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-gray-500 mt-8 uppercase ">
          © 2025 YourCompany — All rights reserved
        </p>
      </div>
    </div> </>
  );
};

export default PreferencePage;
